/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter } from "../../shared";
import { CalendarHierarchyControl } from "./controls/CalendarHierarchyControl";
import { BaseForIndexHierarchyControl } from "./controls/BaseForIndexHierarchy";
import { MethodControl } from "./controls/MethodControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useDescription } from "./hooks/useDescription";
import { SLIDE_NUMBER } from "./constants";

export default React.memo((props: { exportMode?: boolean }) => {
  const { exportMode } = props;

  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const description = useDescription();

  useExportQuery(title, subtitle);
  useFavourite();
  useSubscription();

  const [mathodValue] = useParameter<number>("@method");
  const isMethodIndex = mathodValue === 2;

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          <MethodControl />
          <CalendarHierarchyControl />
          {isMethodIndex && <BaseForIndexHierarchyControl />}
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
});
